<button [attr.data-test]="dataTest" class="blue-stroked-button auth-secondary-button" mat-stroked-button type="button" [routerLink]="route">{{ buttonLabel }}</button>

<p class="auth-secondary-caption">
  {{ captionLabel }}
  <a [attr.data-test]="dataTest" class="auth-secondary-link" [routerLink]="route">{{ linkLabel }}</a>
</p>
